const awsmobile = {
  aws_project_region: 'eu-west-1',
  aws_cognito_region: 'eu-west-1',
  aws_user_pools_id: 'eu-west-1_6V9xNaGHW',
  aws_user_pools_web_client_id: '1ikallaebcc7heunkk5dg2uaou',
  location_endpoint_auth: 'https://api.optimise.loophome.app/v1/geo-location',
  optimise_endpoint_auth: 'https://api.optimise.loophome.app/v1',
  smartmeter_endpoint_auth: 'https://api.optimise.loophome.app/v1/internal/onboarding',
  billing_endpoint_auth: 'https://api.optimise.loophome.app/v1/internal',
  data_bucket: 'https://loop-optimise-instructions-optimise-prod.s3.eu-west-1.amazonaws.com',
  dashboard_url: 'https://optimise.loop.homes',
  signup_simulation_mode: false,
  theme: 'Loop',
};
export default awsmobile;
